import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { ApiBaseResponse } from '../../type';
import type { MemberAppToken, PushListParams, PushListResponse, WebPush } from './type';

export const fetchPushList = async (fanPushListParams: PushListParams) => {
  const res = await fetchExtended(`/v1/push/push_list_bj`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fanPushListParams),
  });

  const result = await res.json();

  return result as PushListResponse;
};

export const fetchGetPushMsg = async () => {
  const res = await fetchExtended(`/v1/push/push_msg`, {
    method: 'POST',
    credentials: 'include',
  });
  const result = await res.json();
  return result as WebPush;
};

export const memberAppToken = async (memberAppToken: MemberAppToken) => {
  const res = await fetchExtended(`/v1/member/app_token`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(memberAppToken),
  });
  const result = await res.json();
  return result as ApiBaseResponse;
};
